// src/pages/salary/components/DeductionsSection.jsx
import { Calculator, Shield, Heart, Building, X, CreditCard, XCircle, ThermometerIcon } from '.';

const DeductionsSection = ({ payrollData, calculatedValues, styles, t, theme, isRTL, onMouseEnter, onMouseLeave }) => {
  const standardDeductions = [
    { category: t.incomeTax,             amount: parseFloat(payrollData.monthlyTax).toFixed(1),         description: t.incomeTaxDesc,           icon: Calculator },
    { category: t.socialInsuranceEmployee,amount: calculatedValues.socialInsurance.toFixed(1),          description: t.socialInsuranceDesc,     icon: Shield },
    { category: t.martyrsFund,            amount: parseFloat(payrollData.martyrsFund).toFixed(2),        rate: '0.05%', description: t.martyrsFundDesc, icon: Heart },
    { category: t.socialInsuranceEmployer,amount: calculatedValues.employerInsurance.toFixed(2),        description: t.employerContributionDesc,icon: Building },
    { category: t.penalties,             amount: payrollData.penalityDaysValue.toFixed(2),               icon: X },
    { category: t.sickLeave,             amount: payrollData.sickLeave25DeductionValue.toFixed(2),      icon: ThermometerIcon },
    { category: t.absentDays,            amount: payrollData.absenceDaysValue.toFixed(2),                icon: XCircle },
  ];

  const advancementDeductions = Array.isArray(payrollData.deductions)
    ? payrollData.deductions.filter((d) => d.type === 'advancement')
    : [];

  return (
    <div style={styles.card1}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', direction: isRTL ? 'rtl' : 'ltr', flexDirection: isRTL ? 'row-reverse' : 'row' }}>
          <Calculator size={24} color="#2e7cba" />
          <h2 style={{ color: theme === 'dark' ? '#ffffff' : '#0f172a', fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: '700', margin: 0 }}>{t.deductionsBreakdown}</h2>
        </div>
      </div>
      <div style={styles.detailsGrid}>
        {standardDeductions.map((item, i) => (
          <div key={i} style={styles.detailCard}>
            <div style={styles.detailHeader}>
              <div style={styles.detailIcon}><item.icon size={24} /></div>
              {item.rate && <span style={styles.detailRate}>{item.rate}</span>}
            </div>
            <h4 style={styles.detailTitle}>{item.category}</h4>
            <p style={styles.detailAmount}>{item.amount} {t.egp}</p>
            {item.description && <p style={styles.detailDescription}>{item.description}</p>}
          </div>
        ))}

        {advancementDeductions.map((d, idx) => (
          <div key={`adv-${d.id || idx}`} style={styles.detailCard} >
            <div style={styles.detailHeader}><div style={styles.detailIcon}><CreditCard size={24} /></div></div>
            <h4 style={styles.detailTitle}>{isRTL ? 'سلفة' : 'Advancement (Solfa)'}</h4>
            <p style={styles.detailAmount}>{parseFloat(d.amount).toFixed(2)} {t.egp}</p>
            {d.description && <p style={styles.detailDescription}>{d.description}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeductionsSection;